<template>
  <div class="receipt-88">
      <div v-html="deliveryHtml">

    </div>
  </div>
</template>
<style type="text/css">

 .receipt-88 h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, div{
      color: #000;
  }
</style>
<script>
const API_URL = process.env.VUE_APP_API;

export default {
  name: "delivery",
  data(){
    return {
        deliveryHtml:""
    };
  },
  mounted() {
    this.getDelivery();
  }, 
  methods: {
    getDelivery(){
    this.$http
      .get(API_URL + "/order/"+this.$route.params.deliveryId+"/delivery", {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      })
      .then(res => {
        this.deliveryHtml = res.data.data
      });
    },
  }
};
</script>
<style>
</style>